// packages/components/src/support-ai/ProblemStatement.tsx
import React, { useState } from 'react';
import { IconButton } from '@dopomogai/ui';
import { Languages, MessageSquareDashed } from 'lucide-react';
import clsx from 'clsx';

interface ProblemStatementProps {
  originalQuery: string;
  // NEW: Add prop for the translated version
  translatedQuery?: string;
  language?: string;
  className?: string;
}

export const ProblemStatement: React.FC<ProblemStatementProps> = ({
  originalQuery,
  translatedQuery,
  language = 'Original',
  className,
}) => {
  // NEW: State to manage the toggle
  const [showTranslation, setShowTranslation] = useState(true);
  const canTranslate = !!translatedQuery && originalQuery !== translatedQuery;

  const toggleTranslation = () => {
    if (canTranslate) {
      setShowTranslation(prev => !prev);
    }
  };
  
  const textToShow = showTranslation ? translatedQuery : originalQuery;

  return (
    <div className={clsx("p-4 bg-white border-b-2 border-dashed border-slate-200", className)}>
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-sm font-bold text-slate-800 flex items-center gap-2">
          <MessageSquareDashed size={16} />
          Customer's Initial Query
        </h3>
        {canTranslate && (
          <IconButton
            icon={<Languages size={16} />}
            variant="ghost"
            size="sm"
            onClick={toggleTranslation}
            tooltip={`Show ${showTranslation ? language : 'English Translation'}`}
          />
        )}
      </div>

      <blockquote className="border-l-4 border-emerald-400 pl-4 py-2 bg-emerald-50/50 rounded-r-md">
        <p className="text-sm italic text-slate-700">{textToShow}</p>
      </blockquote>
    </div>
  );
};